import Vue from 'vue';
import Vuex from 'vuex';
import store from 'store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      head: store.get('head'),
      name: store.get('name')
    }
  },
  mutations: {
    user(state, v) {
      state.user = v
      store.set('name', v.name);
      store.set('head', v.head);
    }
  },
  actions: {},
});
